/**
 * Created by Carsten Bühler
 * User: c.buehler on 12.07.2021
 * Copyright: xdot GmbH 2021
 */


export default function formatMeasurements(doubleValue) {
    if (doubleValue>1000){
        return doubleValue.toFixed(0);
    } else if (doubleValue > 100){
        return doubleValue.toFixed(1);
    } else {
        return doubleValue.toFixed(2);
    }
}


// WEBPACK FOOTER //
// ./js/utils/formating-util.js